import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ClientSyncStatusComponent } from 'src/app/shared/components/client-sync-status/client-sync-status.component';
import { AmgPubnubModule } from 'src/lib/amg-pubnub/amg-pubnub.module';

@NgModule({
  declarations: [ClientSyncStatusComponent],
  imports: [CommonModule, MatIconModule, AmgPubnubModule],
  exports: [ClientSyncStatusComponent],
})
export class TcsClientSyncModule {}
